import { useSetLoginModal } from '~/modules-rocco/user/hook/use-open-login-modal';
import { useUser } from '~/modules/user';

/**
 * Custom hook to handle opening the login modal or redirecting based on user login status.
 *
 * @returns A function that takes a URL string. If the user is logged in,
 * it redirects the browser to the provided URL. If the user is not logged in,
 * it opens the login modal with the specified redirect URL.
 */
export const useOpenLogin = () => {
    const user = useUser();
    const { setLoginModal } = useSetLoginModal();
    const isLoggedIn = user.__typename === 'Me';

    /**
     * Handles the logic to either redirect or open the login modal.
     * @param url The target URL for redirection or post-login redirect.
     */
    return (url: string) => {
        if (isLoggedIn) {
            window.location.href = url;
        } else {
            setLoginModal({
                authSource: 'homeModule',
                isOpen: true,
                redirect: url === 'login' ? '/' : url,
                title: '',
            });
        }
    };
};
